export type CometUser = {
  email?: string;
  hasStrongAuthentication?: boolean;
  impersonatorEmail?: string;
  impersonatorUserToken?: string;
  isInitialMultiFactorAuthenticationRequired?: boolean;
  isLoggedIn: boolean;
  roles?: Array<string>;
  userToken?: string;
};

function isLoggedIn<User extends CometUser>(
  {
    email,
    hasStrongAuthentication,
    impersonatorEmail,
    impersonatorUserToken,
    isInitialMultiFactorAuthenticationRequired,
    isLoggedIn,
    userToken,
  }: User,
  { requireStrongAuthentication }: { requireStrongAuthentication?: boolean },
) {
  const isImpersonating = impersonatorEmail && impersonatorUserToken;

  if (!isLoggedIn || (!isImpersonating && isLoggedIn && !email && !userToken)) {
    return false;
  } else if (isImpersonating) {
    return true;
  } else if (isInitialMultiFactorAuthenticationRequired) {
    return false;
  } else if (requireStrongAuthentication && !hasStrongAuthentication) {
    return false;
  } else {
    return true;
  }
}

export function isAuthorized<U>({
  mapUser,
  ...options
}: {
  mapUser: (user: U) => CometUser;

  allRequiredRoles?: Array<string>;
  oneOfRequiredRoles?: Array<string>;
  requireStrongAuthentication?: boolean;
}) {
  return (user: U) => isLoggedIn(mapUser(user), options);
}
